export const BASEURL = "https://meteor.today";

export const TESTBASEURL = "https://meteor-test.batmobile.com.tw";
